import { render, staticRenderFns } from "./ReferralProgramSettings.vue?vue&type=template&id=8e621a72&scoped=true&"
import script from "./ReferralProgramSettings.vue?vue&type=script&lang=js&"
export * from "./ReferralProgramSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e621a72",
  null
  
)

export default component.exports